import React from 'react';

import './Container.css';

export default ({ children }) => (
    <div className="container">
        {children}
    </div>
);
